import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import CertificationsList from "@/components/CertificationsList";
import { useContent } from "@/context/ContentContext";

export default function Skills() {
    const content = useContent();
    return (
        <>
            <PageHeader
                crumb="HOME / SKILLS"
                eyebrow="04 — TOOLKIT"
                lines={["SKILLS"]}
                sub="What I bring to the table — and keep sharpening."
            />
            <section
                className="px-5 lg:px-12 xl:px-16 py-14 lg:py-20 grid gap-8 md:grid-cols-3"
                data-testid="skills-page-grid"
            >
                {content.skills.map((g, gi) => (
                    <Reveal
                        key={g.label}
                        delay={gi * 0.08}
                        className="border border-line bg-paper2 p-8 flex flex-col"
                        data-testid={`skill-group-${gi + 1}`}
                    >
                        <p className="mono text-[11px] tracking-[0.25em] text-muted2">
                            0{gi + 1} — {g.label.toUpperCase()}
                        </p>
                        <div className="mt-8 flex flex-wrap gap-3 content-start">
                            {g.items.map((s) => (
                                <span
                                    key={s}
                                    data-testid={`skill-pill-${s
                                        .toLowerCase()
                                        .replace(/\s+/g, "-")}`}
                                    className="border border-line bg-paper px-4 py-2 text-sm rounded-full transition-colors duration-300 hover:bg-sage hover:text-ink hover:border-sage"
                                >
                                    {s}
                                </span>
                            ))}
                        </div>
                    </Reveal>
                ))}
            </section>

            <section
                className="px-5 lg:px-12 xl:px-16 pb-24"
                data-testid="skills-certifications-section"
            >
                <Reveal>
                    <p className="mono text-[11px] tracking-[0.25em] text-muted2">
                        04 — CERTIFICATIONS
                    </p>
                    <h2 className="font-display text-2xl md:text-3xl tracking-tight mt-3">
                        CERTIFICATIONS
                    </h2>
                </Reveal>
                <div className="mt-8">
                    <Reveal delay={0.1}>
                        <CertificationsList />
                    </Reveal>
                </div>
            </section>
        </>
    );
}
